import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompare } from '../../domain/compare/useCompare';
import { COMPARE_MAX, toggleCompare } from '../../domain/compare/compareStore';

/** Reuse the existing comparison store; no inquiry or lead is submitted. */
export function DetailCompareAction({ propertyId }: { propertyId: number }) {
  const ids = useCompare();
  const navigate = useNavigate();
  const included = ids.includes(propertyId);
  return <button type="button" aria-label={included ? '비교함 보기' : '비교함에 담기'}
    onClick={() => {
      if (included) { navigate('/compare'); return; }
      const result = toggleCompare(propertyId);
      if (result.full) alert(`비교함에는 최대 ${COMPARE_MAX}개 단지를 담을 수 있어요.`);
    }}
    className="flex h-11 w-14 shrink-0 flex-col items-center justify-center rounded-ca-xl border border-accent-dark bg-frame text-[12px] font-semibold text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-ink">
    <span>{included ? '비교함' : '비교'}</span>
    {included && <span className="text-[11px] text-muted">{ids.length}/{COMPARE_MAX}</span>}
  </button>;
}
